export default "__VITE_ASSET__UUdO09Pj__"